<template>
  <div>
    <superAdmin />
  </div>
</template>

<script>
import superAdmin from '@/layouts/superAdmin'

export default {
  components: {
    superAdmin
  }  
}
</script>


// WEBPACK FOOTER //
// src/pages/SuperAdmin/index.vue